import { ICommandBarStyles } from '@fluentui/react'

const commandBarStyles = (): Partial<ICommandBarStyles> => ({
  root: {
    paddingLeft: 0,
    borderBottom: '1px solid #efefef',
    width: '100%',
  },
})

export default commandBarStyles
